"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clamp_1 = __importDefault(require("lodash/clamp"));
class TextModel {
    _text;
    _clampByRange(position) {
        return (0, clamp_1.default)(position, 0, this._text.length);
    }
    constructor(text) {
        this._text = text;
    }
    get text() {
        return this._text;
    }
    getWordIncludingPosition(position) {
        this._clampByRange(position);
        const codePoint = this._text.codePointAt(position);
        if (codePoint === undefined) {
            return null;
        }
        const category = categorizeCodePoint(codePoint);
        // Note: `first` is an inclusive index.
        let first = position;
        while (first - 1 >= 0) {
            const codePoint = this._text.codePointAt(first - 1);
            if (codePoint === undefined ||
                category !== categorizeCodePoint(codePoint)) {
                break;
            }
            first -= 1;
        }
        // Note: `last` is an inclusive index.
        let last = position;
        while (last + 1 < this._text.length) {
            const codePoint = this._text.codePointAt(last + 1);
            if (codePoint === undefined ||
                category !== categorizeCodePoint(codePoint)) {
                break;
            }
            last += 1;
        }
        // [first, last] -> [begin, end)
        return position - first < last - position
            ? [first, last + 1]
            : [last + 1, first];
    }
    deleteBackward(position) {
        position = this._clampByRange(position);
        return this.strip(position - 1, position);
    }
    deleteForward(position) {
        position = this._clampByRange(position);
        return this.strip(position, position + 1);
    }
    strip(begin, end) {
        [begin, end] = sortedCouple(this._clampByRange(begin), this._clampByRange(end));
        return [
            new TextModel(this._text.slice(0, begin) + this._text.slice(end)),
            begin,
        ];
    }
    insert(position, text) {
        position = this._clampByRange(position);
        return [
            new TextModel(this._text.slice(0, position) + text + this._text.slice(position)),
            position + text.length,
        ];
    }
    clampPosition(position) {
        return this._clampByRange(position);
    }
    clampRange([a, b]) {
        return sortedCouple(this._clampByRange(a), this._clampByRange(b));
    }
}
exports.default = TextModel;
function sortedCouple(a, b) {
    return a > b ? [b, a] : [a, b];
}
var CharacterCategory;
(function (CharacterCategory) {
    CharacterCategory[CharacterCategory["Alphabet"] = 0] = "Alphabet";
    CharacterCategory[CharacterCategory["Numeric"] = 1] = "Numeric";
    CharacterCategory[CharacterCategory["Others"] = 2] = "Others";
    CharacterCategory[CharacterCategory["NonAscii"] = 3] = "NonAscii";
})(CharacterCategory || (CharacterCategory = {}));
function categorizeCodePoint(codePoint) {
    if (codePoint <= 255) {
        if ((97 <= codePoint && codePoint <= 122) ||
            (65 <= codePoint && codePoint <= 90)) {
            return CharacterCategory.Alphabet;
        }
        if (48 <= codePoint && codePoint <= 57) {
            return CharacterCategory.Numeric;
        }
        return CharacterCategory.Others;
    }
    return CharacterCategory.NonAscii;
}
